import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { z } from 'zod';

import { useActiveCompany } from '@/lib/active-company-context';
import { useApi } from '@/lib/api-context';

// Candidatos a plantilla de un tipo de documento (G3-4): documentos vigentes de la
// empresa activa, buscados por código o nombre. Solo se pueden elegir los que tienen su
// archivo en el LMS (el API lo valida igual).

export interface TemplateCandidate {
  id: string;
  code: string;
  title: string | null;
  lmsLinked: boolean;
}

const candidateSchema = z.object({
  id: z.string(),
  code: z.string(),
  title: z.string().nullable(),
  lmsLinked: z.boolean(),
});
const responseSchema = z.object({ success: z.literal(true), data: z.array(candidateSchema) });

const MIN_TERM = 2;

export function useTemplateCandidates(term: string): UseQueryResult<TemplateCandidate[]> {
  const api = useApi();
  const { activeCompanyId } = useActiveCompany();
  const q = term.trim();
  return useQuery({
    queryKey: ['template-candidates', activeCompanyId, q],
    queryFn: async () => {
      const params = new URLSearchParams({ status: 'vigente', q, limit: '10' });
      const raw = await api.get<unknown>(`/api/v1/quality/master-list?${params.toString()}`);
      return responseSchema.parse(raw).data;
    },
    enabled: q.length >= MIN_TERM && activeCompanyId !== null,
  });
}
